/**
 * Role constants — must match the claim values in the Okta access token.
 * Use these everywhere role checks are needed (fieldConfig, route guards, UI).
 *
 * Service: phanes
 */
export const ROLE_ADMIN = 'phanes-data-onboarding-admins';
export const ROLE_USER = 'phanes-data-onboarding-users';

const hasAdminRole = (roles: string[]): boolean => roles.includes(ROLE_ADMIN);
const hasUserRole = (roles: string[]): boolean => roles.includes(ROLE_USER);
export const hasAnyRole = (roles: string[]): boolean => hasAdminRole(roles) || hasUserRole(roles);
